import reducer from './reducer'

import * as principalPaymentsOperations from './operations'
import * as principalPaymentsSelectors from './selectors'

export { principalPaymentsOperations, principalPaymentsSelectors }

export default reducer
